import React from "react";
import logo from "../../assets/img/gndrv-logo.png";
import "./Brand.css";

const Brand = () => (
  <div className="brand">
    <img src={logo} className="appLogo" alt="logo" />
    <div className="appTitle">Nature writes spaghetti code.</div>
    <div className="appTitle bold">We can do better.</div>
  </div>
);

export default Brand;



// WEBPACK FOOTER //
// ./src/components/Brand/Brand.js